import React from "react";
import {
  StyleSheet,
  FlatList,
  View,
  Image,
  Text,
  Dimensions,
  TouchableOpacity,
} from "react-native";
import { useNavigation } from "@react-navigation/native";
import { useSelector } from "react-redux";

const windowWidth = Dimensions.get("window").width;
//const thirdGrid = (windowWidth - 180) / 3;
const thirdGrid = 200;
const seventeen = 17;
const tick = require("../assets/res/tickL.png");
const nulltick = require("../assets/res/tickNull.png");

function CharitiesList(props) {
  const selectedCharity = useSelector((state) => state.user.userData.subscriberDetails.charityId);
  const navigation = useNavigation();
  return (
    <FlatList
      contentContainerStyle={styles.flatlistContainer}
      data={props.data}
      renderItem={({ item }) => (
        <TouchableOpacity
          style={styles.gridBox}
          onPress={() => navigation.navigate("DonateDetail", { charity: item })}
        >
          <View style={item.id === selectedCharity ? styles.gridItemActive : styles.gridItem}>
            <Image
              style={styles.imageThumbnail}
              source={{ uri: item.imageUrl }}
              width={thirdGrid}
              heigth={thirdGrid}
              resizeMode="contain"
            />
            {item.id === selectedCharity ? (
              <Image
                style={styles.imageIcon}
                source={tick}
                width={seventeen}
                heigth={seventeen}
                resizeMode="contain"
              />
            ) : (
              <Image
                style={styles.imageIcon}
                source={nulltick}
                width={seventeen}
                heigth={seventeen}
                resizeMode="contain"
              />
            )}
          </View>
        </TouchableOpacity>
      )}
      //Setting the number of column
      //numColumns={3}
      keyExtractor={(item, index) => index.toString()}
      numColumns={3}
    />
  );
}
export default CharitiesList;

const styles = StyleSheet.create({
  imageIcon: {
    margin: 5,
    position: "absolute",
    bottom: 0,
    right: 0,
    width: 17,
    height: 17,
  },

  gridBox: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "space-around",
  },

  gridItem: {
    margin: 2,
    padding: 2,
    justifyContent: 'center',
    alignItems: 'center',
  },

  gridItemActive: {
    margin: 2,
    padding: 2,
    borderColor: "#cccccc",
    borderWidth: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },

  imageThumbnail: {
    height: 100,
    width: 100,
    resizeMode: "contain",
  },
  flatlistContainer: {
    flexDirection: "column",
    //flexWrap: "wrap",
    justifyContent : "space-evenly",
    //maxWidth: 1000,
    paddingTop: 30,
  },
});
